// Dịch ĐỘNG dữ liệu tenant trên /sale (tên loại phòng, tiện ích, ghi chú giá, review…) — phần THUẦN dùng
// chung client + server (KHÔNG import gì có 'use client' hay firebase-admin). Xem lib/sale-i18n-server.ts.

export type SaleTrLang = 'en' | 'zh' | 'ko' | 'fr' | 'ja';
export const SALE_TR_LANG_NAMES: Record<SaleTrLang, string> = {
  en: 'English',
  zh: 'Simplified Chinese (简体中文)',
  ko: 'Korean (한국어, polite 존댓말)',
  fr: 'French (Français, "vous")',
  ja: 'Japanese (日本語, polite です・ます)',
};
export const isSaleTrLang = (l: unknown): l is SaleTrLang => typeof l === 'string' && l in SALE_TR_LANG_NAMES;

export const SALE_TR_MAX_TEXTS = 60;
export const SALE_TR_MAX_TEXT_LEN = 2000;
export const SALE_TR_MAX_TOTAL = 24_000;

/**
 * Text nào KHÔNG cần gọi dịch: rỗng/không có chữ (số, ký hiệu), hoặc ASCII thuần khi đích là English
 * (tiện ích lưu sẵn bằng tiếng Anh gốc Airbnb; tiếng Việt luôn có dấu nên không lọt nhầm vào đây).
 */
export function needsSaleTranslation(text: string, lang: SaleTrLang): boolean {
  if (!text.trim() || !/\p{L}/u.test(text)) return false;
  if (lang === 'en' && !/[^\x00-\x7F]/.test(text)) return false;
  return true;
}
